import React from 'react'

const Navbar = () => {
  return (
    <div className="navbar bg-base-100">
            <a className="normal-case text-lg ml-24 font-bold">
              E-Commerce CRUD
            </a>
    </div>
  )
}

export default Navbar